import React from 'react';
import { Link } from 'react-router-dom';
import GoogleAuth from './googleAuth';
import image from '../../Media/logo.png';
import { connect } from 'react-redux';
import perfil from '../../Media/perfil.png';
import { Image, Dropdown, Col, Row, ButtonGroup, Figure } from 'react-bootstrap';
import NotificationSlack from './notificationSlack';
import NotificationHupp from './notificationHupp';

class Headers extends React.Component {

    state = {
        opcion: null, close: false, menu: null
    };


    render() {

        let opcion = null;
        let menuPerfil = null;
        let notificationsSlack = null;
        let notificationsHupp = null;
        let offset_Var = 2;
        if (this.props.isSignedIn) {
            notificationsSlack = <NotificationSlack />
            notificationsHupp = <NotificationHupp />
            menuPerfil =
                <Dropdown as={ButtonGroup} >
                    <Dropdown.Toggle id="dropdown-custom-1" variant='light' style={{
                        background: 'white',
                        borderRadius: '20em',
                        borderColor: 'white'
                    }} >
                        <Image className='intro_hupity' alt='Imagen perfil Hupper' id="imagePerfilUs" roundedCircle src={this.props.userDetail ? this.props.userDetail.usuario && this.props.isSignedIn ? this.props.userDetail.usuario.imagenPerfil ? this.props.userDetail.usuario.imagenPerfil : perfil : perfil : perfil}  ></Image>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="super-colors" >

                        <Row>
                            <Col>
                                <Row>
                                    <Col xs={{ span: 6, offset: 2 }}>

                                        <Figure>
                                            <Figure.Image
                                                roundedCircle
                                                width={171}
                                                height={180}
                                                alt="profile hupper"
                                                src={this.props.userDetail ? this.props.userDetail.usuario && this.props.isSignedIn ? this.props.userDetail.usuario.imagenPerfil ? this.props.userDetail.usuario.imagenPerfil : perfil : perfil : perfil} className='intro_hupity_profile'
                                            />
                                        </Figure>

                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={{ span: 4, offset: 3 }}>

                                        <h4 >{this.props.userDetail && this.props.userDetail.usuario && this.props.isSignedIn ? this.props.userDetail.usuario.usuario : 'loading...'}</h4>

                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={{ span: 4, offset: 3 }}>
                                        <h6  >{this.props.userDetail && this.props.userDetail.usuario && this.props.isSignedIn ? this.props.userDetail.usuario.cargo : null}</h6>
                                    </Col>
                                </Row>


                            </Col>
                        </Row>

                        <Dropdown.Item eventKey="1">
                            <Link to={"/profile"}>
                                Detalle de tu perfil
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="2"> <GoogleAuth googleIn={true} /></Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
        }
        if (this.props.userDetail && this.props.userDetail.rol === "2") {
            opcion = <Col >
                <Link to="/equipoData" className="item " >
                    <h4 className='center_Menu_Opcion' >Equipo</h4>
                </Link>
            </Col>
            offset_Var = 0;
        }
        return (

            <Row style={{ boxShadow: '0px 1.5px 0px 0px #d45df2' }}>
                <Col xs={2}>
                    <Link to="/dashboard" className="item">
                        <Image className='intro_hupity' src={image} id='1' alt="hupity tu compañero en el trabajo"></Image>
                    </Link>
                </Col >
                <Col md={{ span: 3 - offset_Var, offset: 6 + offset_Var }} xs={{ span: 8 - offset_Var, offset: 2 + offset_Var }}>
                    <Row>
                        {opcion}
                        <Col>
                            {menuPerfil}
                        </Col>
                    </Row>

                </Col>
                {notificationsSlack}
                {notificationsHupp}
            </Row>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        userDetail: state.mainReducer.userDetail,
        isSignedIn: state.mainReducer.isSignedIn,
    };
};

export default connect(mapStateToProps, {})(Headers);

